export interface Bonus {
  number: string;
  title: string;
  description: string;
  imageUrl: string;
}

export const bonuses: Bonus[] = [
  {
    number: "BONO 01",
    title: "Manual de Musculación",
    description:
      "Una guía práctica de biomecánica básica que te ayuda a entender cómo funciona cada ejercicio, qué músculos se activan y cómo enseñarlo correctamente, aumentando tu seguridad y autoridad.",
    imageUrl:
      "https://cdn.magicpatterns.com/patterns/generated-images/1df9979c-8f41-4a7b-8952-e0ed089a2c00.jpg",
  },
  {
    number: "BONO 02",
    title: "Guía de Ejecución Correcta",
    description:
      "Un checklist directo con los errores más comunes y puntos clave, permitiéndote corregir a tus alumnos de forma rápida y objetiva.",
    imageUrl:
      "https://cdn.magicpatterns.com/patterns/generated-images/79ceff21-40e2-48ff-800a-51b7b373cfb2.jpg",
  },
  {
    number: "BONO 03",
    title: "150 Recetas Fitness",
    description:
      "Un material listo con recetas que puedes enviar a tus alumnos para agregar valor, mejorar la experiencia y aumentar la retención.",
    imageUrl:
      "https://cdn.magicpatterns.com/patterns/generated-images/c9467ec8-2cf0-4536-bc5d-a41461b083e6.jpg",
  },
  {
    number: "BONO 04",
    title: "Planilla de Periodización Automatizada",
    description:
      "Una planilla lista que facilita la creación de entrenamientos organizados, ayudando en la progresión y ahorrando tiempo.",
    imageUrl:
      "https://cdn.magicpatterns.com/patterns/generated-images/cbaf16f5-20fa-48b2-bdad-a9f588e9d3f7.jpg",
  },
];
